import { s } from "../../../../utilities/common"

export const InfoIcon = () => {
  return (
    <svg
      style={{ marginLeft: s("20px") }}
      width={s("40")}
      height={s("40")}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.3333 28.3277H21.6667V16.6367C21.6667 15.7494 20.8854 14.9665 20 14.9665H16.6667C15.7292 14.9665 15 15.7494 15 16.6367C15 17.5761 15.7292 18.3068 16.6667 18.3068H18.3333V28.3277H16.6667C15.7292 28.3277 15 29.0584 15 29.9978C15 30.8851 15.7292 31.668 16.6667 31.668H23.3333C24.2188 31.668 25 30.8851 25 29.9978C25 29.0584 24.2188 28.3277 23.3333 28.3277ZM20 11.6262C21.3542 11.6262 22.5 10.5302 22.5 9.121C22.5 7.764 21.3542 6.66797 20 6.66797C18.5938 6.66797 17.5 7.764 17.5 9.17319C17.5 10.5302 18.5938 11.6262 20 11.6262Z"
        fill="#303949"
      />
    </svg>
  )
}
